import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { disableMiddlewareLogPM } from '@api/middlewareSMO';

import { ESnackbarTypes } from '@enums/common';

import { MIDDLEWARE_LOG_PM_DISABLE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

import useInvalidateMiddlewareSMO from './useInvalidateMiddlewareSMO';

interface IUseMutateMiddlewareDisableLogPMReturned {
	disableMiddlewareLogPM: (id: string) => void;
	isLoadingDisableMiddlewareLogPM: boolean;
}

const useMutateMiddlewareDisableLogPM = (handleCloseModal: () => void): IUseMutateMiddlewareDisableLogPMReturned => {
	const dispatch = useAppDispatch();
	const invalidateMiddlewareSMO = useInvalidateMiddlewareSMO();

	const {
		isLoading,
		mutate,
	} = useMutation<string>({
		mutationKey: [MIDDLEWARE_LOG_PM_DISABLE],
		mutationFn: disableMiddlewareLogPM,
		onSuccess: () => {
			handleCloseModal();

			dispatch(setSnackbar({
				message: responseMessages.disableLogPMFile,
				type: ESnackbarTypes.success,
			}));

			return invalidateMiddlewareSMO();
		},
	});

	return {
		disableMiddlewareLogPM: mutate,
		isLoadingDisableMiddlewareLogPM: isLoading,
	};
};

export default useMutateMiddlewareDisableLogPM;
